import React, { useState, useContext, useCallback, useEffect } from "react"
import { RootContext } from 'RootContext';

// core components
import { Accordion, AccordionSummary } from '@material-ui/core'
import AccordionDetails from '@material-ui/core/AccordionActions'
import AddIcon from "@material-ui/icons/Add"
import Button from "@material-ui/core/Button"
import Card from "components/Card/Card.js"
import CardBody from "components/Card/CardBody.js"
import CardHeader from "components/Card/CardHeader.js"
import CircularProgress from "@material-ui/core/CircularProgress"
import Dialog from "@material-ui/core/Dialog"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"
import DialogContentText from "@material-ui/core/DialogContentText"
import DialogTitle from "@material-ui/core/DialogTitle"
import ExpandMoreIcon from "@material-ui/icons/ExpandMore"
import Fab from "@material-ui/core/Fab"
import Grid from "@material-ui/core/Grid"
import IconButton from "@material-ui/core/IconButton"
import RefreshIcon from "@material-ui/icons/Refresh"
import Tooltip from "@material-ui/core/Tooltip"
import Typography from "@material-ui/core/Typography"
import { fetchWithToken } from "components/Fetch/api-fetch"
import { titleCase } from "title-case"

// CSS
import { useJobsStyles } from "styles/jobs/jobsCss"

//Pegaso component
import ErrorUtils from "components/Tools/ErrorUtils"
import Frame from "views/FramesManagement/Frame"
import FrameListToolbar from "views/FramesManagement/FrameListToolbar"
import FrameListTable from "views/FramesManagement/FrameListTable"

export default function FramesList(props) {
  const { companyId, t, apiUrl, access_token, refresh_token, setAccess_token, } = useContext(RootContext)
  const { framesRows, frameBrands, frameSuppliers, frameSuppliersFilterOption, frameBrandsFilterOption, setFramesRows, setIsFetchingFrames, isFetchingFrames, setCountFramesRows, countFramesRows } = props

  const [actionFetch, setActionFetch] = useState(false)
  const classes = useJobsStyles()
  const [creation, setCreation] = useState(false)
  const [dialogMsg, setDialogMsg] = useState("")
  const [frameData, setFrameData] = useState("")
  const [frameSupplierId, setFrameSupplierId] = useState("")
  const [frameBrandId, setFrameBrandId] = useState("")
  const [frameBrandsToShow, setFrameBrandsToShow] = useState(frameBrandsFilterOption)
  const [frameToDelete, setFrameToDelete] = useState("")
  const [rowsPerPage, setRowsPerPage] = useState(5)
  const [openFrame, setOpenFrame] = useState(false)
  const [openDialog, setOpenDialog] = useState(false)
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false)
  const [orderBy, setOrderBy] = useState("")
  const [order, setOrder] = useState("desc")
  const [refresh, setRefresh] = useState(false)
  const [page, setPage] = useState(0)
  const [searchModelName, setSearchModelName] = useState("")



  /*
    **      HANDLE EVENTS - FETCH
    */

  // Fetch Open frame
  function fetchFrameGet(frameId) {
    const url = `${apiUrl}/companies/${companyId}/frame/${frameId}`
    fetchWithToken(url, {
      method: "GET",
      headers: {
        Accept: +"application/json",
        "Content-Type": "application/json"
      },
      apiUrl: apiUrl,
      companyId: companyId,
      access_token: access_token,
      refresh_token: refresh_token,
      setAccess_token: setAccess_token,
    })
      .then((response) => {
        return response.body // data
      })
      .then((data) => {
        // Se la forma esiste
        setActionFetch(false)
        setFrameData(data)
      })
      .catch((err) => {
        // Se Frame non esiste
        setActionFetch(false)
        setFrameData("")
        setOpenFrame(false)
        setDialogMsg(t(""))
        setOpenDialog(true)
        ErrorUtils.errorLog(`${url} => fetchFrameGet Error`, err.message)
      })
  }

  // Fetch dei frame per supplier
  const fetchFramesBySupplier = useCallback((frameSupplierId) => {
    const url = `${apiUrl}/companies/${companyId}/listFrames/frameSupplier/${frameSupplierId}`
    fetchWithToken(url, {
      method: "GET",
      headers: {
        Accept: +"application/json",
        "Content-Type": "application/json"
      },
      apiUrl: apiUrl,
      companyId: companyId,
      access_token: access_token,
      refresh_token: refresh_token,
      setAccess_token: setAccess_token
    })
      .then(response => {
        const body = response.body
        const { frames } = body
        setFramesRows(frames)
        setCountFramesRows(frames.length)
        setIsFetchingFrames(false)
      })
      .catch(err => {
        setIsFetchingFrames(false)
        ErrorUtils.errorLog(`${url} => fetchFramesBySupplier Error`, err.message)
      })
  }, [access_token, apiUrl, companyId, refresh_token, setAccess_token,
    setFramesRows, setIsFetchingFrames, setCountFramesRows])

  // Fetch dei frame per brand
  const fetchFramesByBrand = useCallback((frameBrandId) => {
    const url = `${apiUrl}/companies/${companyId}/listFrames/frameBrand/${frameBrandId}`
    fetchWithToken(url, {
      method: "GET",
      headers: {
        Accept: +"application/json",
        "Content-Type": "application/json"
      },
      apiUrl: apiUrl,
      companyId: companyId,
      access_token: access_token,
      refresh_token: refresh_token,
      setAccess_token: setAccess_token
    })
      .then(response => {
        const body = response.body
        const { frames } = body
        setFramesRows(frames)
        setCountFramesRows(frames.length)
        setIsFetchingFrames(false)
      })
      .catch(err => {
        setIsFetchingFrames(false)
        ErrorUtils.errorLog(`${url} => fetchFramesByBrand Error`, err.message)
      })
  }, [access_token, apiUrl, companyId, refresh_token, setAccess_token,
    setFramesRows, setIsFetchingFrames, setCountFramesRows])

  // Fetch dei frame per supplier e brand
  const fetchFramesBySupplierAndBrand = useCallback((frameSupplierId, frameBrandId) => {
    const url = `${apiUrl}/companies/${companyId}/listFrames/frameSupplier/${frameSupplierId}/frameBrand/${frameBrandId}`
    fetchWithToken(url, {
      method: "GET",
      headers: {
        Accept: +"application/json",
        "Content-Type": "application/json"
      },
      apiUrl: apiUrl,
      companyId: companyId,
      access_token: access_token,
      refresh_token: refresh_token,
      setAccess_token: setAccess_token
    })
      .then(response => {
        const body = response.body
        const { frames } = body
        setFramesRows(frames)
        setCountFramesRows(frames.length)
        setIsFetchingFrames(false)
      })
      .catch(err => {
        setIsFetchingFrames(false)
        ErrorUtils.errorLog(`${url} => fetchFramesBySupplierAndBrand Error`, err.message)
      })
  }, [access_token, apiUrl, companyId, refresh_token, setAccess_token,
    setCountFramesRows, setFramesRows, setIsFetchingFrames])

  // Fetch dei frame per model id
  const fetchFramesByModelId = useCallback((modelName) => {
    const url = `${apiUrl}/companies/${companyId}/listFrames/modelName/${modelName}`
    fetchWithToken(url, {
      method: "GET",
      headers: {
        Accept: +"application/json",
        "Content-Type": "application/json"
      },
      apiUrl: apiUrl,
      companyId: companyId,
      access_token: access_token,
      refresh_token: refresh_token,
      setAccess_token: setAccess_token
    })
      .then(response => {
        const body = response.body
        const { frames } = body
        setFramesRows(frames)
        setCountFramesRows(frames.length)
        setIsFetchingFrames(false)
      })
      .catch(err => {
        setIsFetchingFrames(false)
        ErrorUtils.errorLog(`${url} => fetchFramesByModelId Error`, err.message)
      })

  }, [access_token, apiUrl, companyId, refresh_token, setAccess_token,
    setFramesRows, setIsFetchingFrames, setCountFramesRows])

  // Fetch Delete
  function fetchDeleteFrame() {
    setActionFetch(true)
    const url = `${apiUrl}/companies/${companyId}/frame/${frameToDelete}`
    fetchWithToken(url, {
      method: "DELETE",
      headers: {
        Accept: +"application/json",
        "Content-Type": "application/json"
      },
      apiUrl: apiUrl,
      companyId: companyId,
      access_token: access_token,
      refresh_token: refresh_token,
      setAccess_token: setAccess_token,
    })
      .then((response) => {
        return response.body // data
      })
      .then((data) => {
        // Se ha eliminato
        setOpenDeleteDialog(false)
        setActionFetch(false)
        setRefresh(true)
      })
      .catch((err) => {
        // Se non riese a eliminare
        setActionFetch(false)
        setFrameData("")
        setOpenFrame(false)
        setDialogMsg(t("52"))
        setOpenDialog(true)
        ErrorUtils.errorLog(`${url} => fetchDeleteFrame Error`, err.message)
      })
  }


  //chiusura del pannello per errore
  const handleClose = () => {
    setOpenDialog(false)
    handleCloseDelete()
  }

  // Click Open New Frame
  function handleClickOpenNew() {
    setOpenFrame(true)
    setCreation(true)
  }

  // Click Close Frame
  function handleClickClose() {
    setFrameData("")
    setOpenFrame(false)
    setCreation(false)
  }

  // Click Open Frame
  function handleClickOpen(frameId) {
    setOpenFrame(true)
    setActionFetch(true)
    setCreation(false)
    fetchFrameGet(frameId)
  }

  //Click Open dialog delete
  function handleClickDelete(frameId) {
    setFrameToDelete(frameId)
    setOpenDeleteDialog(true)
  }

  //Click Close dialog delete
  function handleCloseDelete() {
    setOpenDeleteDialog(false)
    setFrameToDelete("")
  }

  // Click refresh
  function handleClickRefresh() {
    setFramesRows([])
    setCountFramesRows(0)
    setPage(0)
    setRefresh(true)
  }


  function handleChangeFilter(filterField, targetValue) {
    setFramesRows([])
    setCountFramesRows(0)
    setPage(0)
    if (filterField === "frameSupplier") {
      // Rifiltra i brands di quel supplier
      var newFrameBrands = frameBrandsFilterOption
      if (targetValue !== "" && targetValue !== "0") {
        newFrameBrands = frameBrands.filter(option => {
          return (parseInt(option.frameSupplier.frameSupplierId) === parseInt(targetValue))
        })
        newFrameBrands = newFrameBrands.map(option => {
          var newElem = {
            value: option.frameBrandId,
            text: option.frameBrandId + " - " + option.frameBrandName
          }
          return newElem
        })
        newFrameBrands.unshift({
          value: 0,
          text: ""
        })
      }
      setFrameBrandsToShow(newFrameBrands)
      setFrameSupplierId(targetValue)
    }
    else if (filterField === "frameBrand") {
      setFrameBrandId(targetValue)
    }
    else if (filterField === "searchModelName") {
      setSearchModelName(targetValue)
    }
    setRefresh(true)
  }


  // Click sort by coloumn
  function handleRequestSort(event, property) {
    const isDesc = orderBy === property && order === "desc"
    setOrder(isDesc ? "asc" : "desc")
    setOrderBy(property)
  }

  useEffect(() => {
    if (refresh) {
      if (searchModelName !== "") {
        setIsFetchingFrames(true)
        fetchFramesByModelId(searchModelName)
      } else if (frameSupplierId !== "" && frameSupplierId !== "0" && frameBrandId !== "" && frameBrandId !== "0") {
        setIsFetchingFrames(true)
        fetchFramesBySupplierAndBrand(frameSupplierId, frameBrandId)
      } else if (frameBrandId !== "" && frameBrandId !== "0") {
        setIsFetchingFrames(true)
        fetchFramesByBrand(frameBrandId)
      } else if (frameSupplierId !== "" && frameSupplierId !== "0") {
        setIsFetchingFrames(true)
        fetchFramesBySupplier(frameSupplierId)
      }
      setRefresh(false)
    }
  }, [frameBrandId, frameSupplierId,
    fetchFramesBySupplier, fetchFramesByBrand, fetchFramesBySupplierAndBrand, fetchFramesByModelId,
    searchModelName, setIsFetchingFrames, refresh, setRefresh])


  return (
    <div>
      {/*Pannello filtri*/}
      {<Accordion defaultExpanded={true}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography className={classes.heading}>{titleCase(t("10087"))}</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Card>
            <CardHeader color="primary">
              <FrameListToolbar
                frameBrandId={frameBrandId}
                frameSupplierId={frameSupplierId}
                handleChangeFilter={(filterField, targetValue) => {
                  handleChangeFilter(filterField, targetValue)
                }}
                selectOptionFrameSuppliers={frameSuppliersFilterOption}
                selectOptionFrameBrands={frameBrandsToShow}
              />
            </CardHeader>
          </Card>
        </AccordionDetails>
      </Accordion>}
      <Card>
        <CardBody>

          <Grid container direction="row-reverse" justifyContent="space-between">
            {/* TASTO NUOVO FRAME */}
            <Grid item xs={1}>
              {" "}
              <Tooltip title={t("10382")}>
                <Fab
                  color="primary"
                  onClick={handleClickOpenNew}
                  aria-label="add"
                  align="right"
                >
                  <AddIcon />
                </Fab>
              </Tooltip>
            </Grid>

            {/* TASTO REFRESH JOBS*/}
            <Grid item xs={1}>
              <Tooltip title={t("10218")}>
                <IconButton
                  onClick={handleClickRefresh}
                  aria-label="refresh"
                  align="left"
                >
                  <RefreshIcon />
                </IconButton>
              </Tooltip>
            </Grid>

            <Grid item xs={10}></Grid>
          </Grid>

          {isFetchingFrames ? (
            <CircularProgress size={42} style={{ marginLeft: '50%' }} />
          ) : (<div>
            <FrameListTable
              countFramesRows={countFramesRows}
              handleClickDelete={handleClickDelete}
              handleClickOpen={handleClickOpen}
              isFullTable={true}
              onRequestSort={handleRequestSort}
              order={order}
              orderBy={orderBy}
              page={page}
              rows={framesRows}
              rowsPerPage={rowsPerPage}
              setPage={setPage}
              setRowsPerPage={setRowsPerPage}
            />

          </div>
          )}

        </CardBody>
      </Card>


      {/*DIALOG INSERIMENTO FRAME*/}
      <Dialog
        onClose={handleClickClose}
        aria-labelledby="customized-dialog-title"
        open={openFrame}
        maxWidth="xl"
      >
        <DialogContent>
          <Frame
            creation={creation}
            frame={frameData}
            frameBrands={frameBrands}
            frameSuppliers={frameSuppliers}
            frameBrandsFilterOption={frameBrandsFilterOption}
            frameSuppliersFilterOption={frameSuppliersFilterOption}
            onHandleClose={handleClickClose}
            setRefresh={setRefresh}
          />
        </DialogContent>
      </Dialog>

      {/*DIALOG PER ERRORE FETCH*/}
      <Dialog
        open={openDialog}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{t("28")}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {dialogMsg}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary" autoFocus>
            {" "}
            Ok{" "}
          </Button>
        </DialogActions>
      </Dialog>

      {/*DIALOG PER ELIMINAZIONE FRAME*/}
      <Dialog
        open={openDeleteDialog}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{t("28")}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {t("10426")}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={fetchDeleteFrame} color="primary" autoFocus>
            {" "}
            {t("10244")}{" "}
          </Button>

          <Button onClick={handleCloseDelete} color="primary" autoFocus>
            {" "}
            {t("10243")}{" "}
          </Button>
        </DialogActions>
      </Dialog>

      {/* DIALOG LOADING */}
      <Dialog
        aria-labelledby="customized-dialog-title"
        open={actionFetch}
        maxWidth="xl"
      >
        <DialogContent>
          <CircularProgress size={42} style={{ color: "primary" }} />
        </DialogContent>
      </Dialog>
    </div>
  )
}